import { render } from "./SmallArrowTagOn.vue?vue&type=template&id=27056e4e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SmallArrowTagOn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27056e4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27056e4e', __exports__)) {
    api.reload('27056e4e', __exports__)
  }
  
  module.hot.accept("./SmallArrowTagOn.vue?vue&type=template&id=27056e4e", () => {
    api.rerender('27056e4e', render)
  })

}


export default __exports__